<template>
  <v-card width="260" :class="cardClass" :elevation="dndCallOver ? 14 : 3"
    @dragover.prevent="dragOver" @dragleave.prevent="dragLeave"
    @drop.prevent="dndDrop" :color="dndCallOver ? 'light-blue' : ''">

    <v-card-title class="pb-0 title">
      <StatusAvatar class="buddy-avatar" :user="buddy" avatar-size="36px" badge-size="12px"/>
      <span class="buddy-exten text-truncate ml-4">{{ buddy.exten }}</span>
      <v-spacer></v-spacer>
      <BuddyPrefs :buddy="buddy"/>
    </v-card-title>
    <v-card-subtitle class="buddy-name subtitle-1 pb-0 blue-grey--text text-truncate">
      {{ buddy.name }}
    </v-card-subtitle>

    <div v-if="compactView" class="compact-view">
      <v-divider></v-divider>
      <CallTime v-if="displayCallers" :calls="buddy.calls" :lightMode="true" :nameFontSize="14"
        style="position: absolute; top: 56px; right: 0; width: auto; padding: 0px 6px;" />
      <v-card-actions>
        <div class="text-truncate">{{ buddy.department }}</div>
        <v-spacer></v-spacer>
        <ActionsCompactMenu :buddy="buddy"/>
      </v-card-actions>
    </div>
    <div v-else class="extended-view">
      <v-card-text>
        <div class="status-text caption blue-grey--text">{{ $t(buddy.note) }}</div>
        <div class="chat-presence-text caption blue-grey--text">{{ $t(statusTextKey) }}</div>
        <div class="blue-grey--text text-truncate">
          <v-icon color="blue-grey" size="18" light>mdi-folder-account</v-icon>
          {{ $t('buddy.card.dept') }}: {{ buddy.department }}
        </div>

        <CallTime :calls="buddy.calls" v-if="displayCallers" />

      </v-card-text>
      <v-divider></v-divider>

      <BuddyActions :buddy="buddy"/>
    </div>
    <TransferCallDialog :buddy="buddy" :confirmXferDlg="confirmXferDlg" :xferCallId="xferCallId"
    :xferNumber="xferNumber" @close-xfer-dialog="closeXferDialog"/>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatusAvatar from './status_avatar'
import BuddyPrefs from './buddy_prefs'
import BuddyActions from './actions_panel'
import ActionsCompactMenu from './actions_compact_menu'
import CallTime from './calltime'
import TransferCallDialog from './transfer_call_dialog.vue'

export default {
  name: 'buddy-card',
  data () {
    return {
      confirmXferDlg: false,
      xferCallId: '',
      xferNumber: '',
      dndCallOver: false
    }
  },
  props: {
    buddy: {
      type: Object,
      required: true
    }
  },
  components: {
    StatusAvatar,
    BuddyActions,
    BuddyPrefs,
    ActionsCompactMenu,
    CallTime,
    TransferCallDialog
  },
  computed: {
    ...mapGetters({
      canShowCallers: 'permissions/showBuddyCallers',
      compactView: 'users/compactView',
      chatUsers: 'chat/users',
      presences: 'chat/presences',
      sort: 'users/sort'
    }),
    draggable () {
      return this.sort?.match('custom')
    },
    displayCallers: function () {
      return this.buddy.isOnCall && this.canShowCallers(this.buddy.id)
    },
    cardClass: function () {
      let css = 'ma-2'
      if (this.draggable) {
        css = 'buddy-card ma-2'
      }
      return css
    },
    presence () {
      /* buddies don't have usernames and presence doesn't have extensions, so we need to map them through chatUsers */
      const chatUser = this.chatUsers.find((chatUser) => chatUser.exten === this.buddy.exten) ?? null
      const presence = this.presences.find((presence) => chatUser?.chat_username === presence.userId) ?? { status: 'offline', statusText: null }
      return presence
    },
    statusTextKey () {
      /* Use buddy.status. keys because they're much more descriptive */
      switch (this.presence.status) {
        case 'online':
          return 'buddy.status.online'
        case 'away':
          return 'buddy.status.away'
        case 'busy':
          return 'buddy.status.busy'
        case 'offline':
        default:
          return 'buddy.status.offline'
      }
    }
  },
  methods: {
    ...mapActions({
      xferCall: 'sipua/xferCall'
    }),
    dragOver: function (e) {
      if (e.dataTransfer.types.includes('call/json')) {
        this.dndCallOver = true
      }
    },
    dragLeave: function (e) {
      this.dndCallOver = false
    },
    dndDrop: function (e) {
      if (!this.dndCallOver) return
      const data = e.dataTransfer.getData('call/json')
      if (!data) {
        this.dbg('ERROR: Failed call x-fer. Missing drag-n-drop call json data')
        return
      }
      const call = JSON.parse(data)
      this.xferCallId = call.callid
      this.xferNumber = call.number
      this.dndCallOver = false
      this.confirmXferDlg = true
    },
    closeXferDialog () {
      this.confirmXferDlg = false
      this.xferCallId = ''
      this.xferNumber = ''
    }
  }
}
</script>

<style scoped>
.buddy-card.v-card { cursor: move; }
.buddy-name { margin-top: 5px; }
.buddy-avatar { cursor: default; }
.status-text { display: none; }
</style>
